// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reU6_FlCa9Czb5VBM0P0{width:100%;height:100%;display:flex;flex-direction:column}.MWVtHUY3AyMNAxv15c3_{margin:0 30px 24px auto}`, "",{"version":3,"sources":["webpack://./src/pages/contacts/ui/ContactsContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,WAAA,CACA,YAAA,CACA,qBAAA,CAEF,sBACE,uBAAA","sourcesContent":[".contentContainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.searchContainer {\n  margin: 0 30px 24px auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `reU6_FlCa9Czb5VBM0P0`,
	"searchContainer": `MWVtHUY3AyMNAxv15c3_`
};
export default ___CSS_LOADER_EXPORT___;
